import { Box, Flex, ThemeUIStyleObject } from "@powerledger/ui-component-lib";

export const AttentionBadge = ({
  children,
  isIconButton = false,
  showAttentionBadge = false,
  indicatorSX,
}: {
  children: React.ReactNode;
  isIconButton?: boolean;
  showAttentionBadge?: boolean;
  indicatorSX?: ThemeUIStyleObject;
}) => {
  if (!showAttentionBadge) {
    return <>{children}</>;
  }

  return (
    <Flex
      data-testid="attention-badge"
      sx={{
        position: "relative",
        width: "fit-content",
      }}
    >
      {children}
      <Box
        data-testid="attention-badge-indicator"
        sx={{
          position: "absolute",
          top: isIconButton ? "-8px" : "2px",
          right: isIconButton ? "-10px" : "4px",
          width: "6px",
          height: "6px",
          backgroundColor: "#E1002D",
          borderRadius: "50%",
          pointerEvents: "none",
          zIndex: 1,
          m: 1,
          animation: "pulse 1.5s infinite",
          "@keyframes pulse": {
            "0%": {
              transform: "scale(1)",
              opacity: 1,
            },
            "50%": {
              transform: "scale(1.4)",
              opacity: 0.6,
            },
            "100%": {
              transform: "scale(1)",
              opacity: 1,
            },
          },
          ...indicatorSX,
        }}
      />
    </Flex>
  );
};
